// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l3CvNa2V8YI3Z92yhZVg {
    padding: 32px 8px 0;
}

.RntGCVZzQ2PmhCPAdmM2 {
    display: flex;
    margin-top: 16px;
    gap: 16px;
    flex-direction: row;
    align-items: flex-start;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/AppointmentBooking.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".wrapper {\n    padding: 32px 8px 0;\n}\n\n.contentContainer {\n    display: flex;\n    margin-top: 16px;\n    gap: 16px;\n    flex-direction: row;\n    align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `l3CvNa2V8YI3Z92yhZVg`,
	"contentContainer": `RntGCVZzQ2PmhCPAdmM2`
};
export default ___CSS_LOADER_EXPORT___;
